// discoveryStateSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ConnectionResponse } from './ApplicationCard';

export interface DiscoverySaveConnectionState {
  loading: boolean;
  errorData: object | unknown;
  data: ConnectionResponse | null;
}

const initialState: DiscoverySaveConnectionState = {
  loading: false,
  errorData: null,
  data: null,
};

const discoverySaveConnectionSlice = createSlice({
  name: 'discoverySaveConnection',
  initialState,
  reducers: {
    setDiscoverySaveConnectionLoading: (
      state,
      action: PayloadAction<boolean>
    ) => ({
      ...state,
      loading: action.payload,
    }),
    setDiscoverySaveConnectionResult: (
      state,
      action: PayloadAction<ConnectionResponse | null>
    ) => ({
      ...state,
      data: action.payload,
    }),
    setDiscoverySaveConnectionError: (
      state,
      action: PayloadAction<object | unknown>
    ) => ({
      ...state,
      errorData: action.payload,
    }),
    resetDiscoverySaveConnectionState: () => initialState,
  },
});

export const {
  setDiscoverySaveConnectionError,
  setDiscoverySaveConnectionResult,
  setDiscoverySaveConnectionLoading,
  resetDiscoverySaveConnectionState,
} = discoverySaveConnectionSlice.actions;
export default discoverySaveConnectionSlice;
